import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=e1f31c4e&scoped=true"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"
import style0 from "./NewGroup.vue?vue&type=style&index=0&id=e1f31c4e&prod&scoped=true&lang=less"
import style1 from "./NewGroup.vue?vue&type=style&index=1&id=e1f31c4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f31c4e",
  null
  
)

export default component.exports